import React, {
  useEffect,
  useState
} from "react";
import {
  Card,
  CardBody,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  TabContent,
  TabPane,
  Progress,
  NavLink,
  NavItem,
  Button,
  CardTitle,
  FormFeedback,
  FormText,
} from "reactstrap";
import classnames from "classnames";
import Async from 'react-select/async';
import moment from "moment";
import { Link, Navigate } from "react-router-dom";
import { AMC_STATUS_OPTIONS, NO_OF_SWITCHES } from "../../store/device/actionTypes";
import { getOrganisationsForAsyncSelect } from "../../store/organisation/actions";
import { getAssignableProductsForAsyncSelect } from "../../store/products/actions";
import {
  addDeviceForm,
  addDevices,
  clearCreateDeviceError,
  getLastSerialNumber
} from "../../store/device/actions";
import { connect } from "react-redux";
import { SUPER_ADMIN } from "../../store/users/role.constants";
import Message from "../../CommonData/Data/Message";
import { clearForm, updateForm } from "../../store/form/actions";
import VWLoading from "../../components/vwLoading/vwLoading";
import { v4 as uuidv4 } from 'uuid';
import './style.scss'

const FormWizard = (props) => {
  const { lastSerialNo, form, currentProfile, errorMessage, isPending } = props;

  const [activeTabwiz, setoggleTabwiz] = useState(1);
  const [new_user_organisation, setNewUserOrg] = useState();
  const [new_product, setNewProductOrg] = useState();
  const [passedStepswiz, setpassedStepswiz] = useState([1]);
  const [no_of_switches, setNoOfSwitches] = useState([1]);
  const [validationDate, setValidationDate] = useState();
  const [amcDate, setAmcDate] = useState();
  const currentRole = currentProfile.roles && currentProfile.roles.length > 0 && (currentProfile.roles[0])
  const isSuperAdmin = currentRole && currentRole.roleKey === SUPER_ADMIN;

  useEffect(() => {
    const { updateForm, clearForm, clearCreateDeviceError } = props || {};
    const switchesCount = 4;
    const validDate = moment().add(1, "year").format("YYYY-MM-DD");
    const amcStartDate = moment().format("YYYY-MM-DD");
    const amcEndDate = moment().add(1, "year").format("YYYY-MM-DD");
    setAmcDate({
      ...amcDate,
      amcStartDate: amcStartDate,
      amcEndDate: amcEndDate,
    })
    setValidationDate(validDate);
    setNoOfSwitches(switchesCount);
    if (!isSuperAdmin) {
      setNewUserOrg({
        label: currentRole.orgName,
        value: currentRole.orgId,
      })
    }
    updateForm({
      formAddDevice: {
        formAddDevice1: {
          numOfSwitches: 4
        },
        formAddDevice2: {
          new_user_organisation: !isSuperAdmin ? currentRole.orgId : null,
          SubscriptionValidate: validDate,
        },
        formAddDevice3: {
          amcStartDate: amcStartDate,
          amcEndDate: amcEndDate,
        },
        errors1: {},
        errors2: {},
        errors3: {},
      }
    })

    clearCreateDeviceError()
    return () => {
      clearCreateDeviceError()
      clearForm();
    }
  }, [])

  useEffect(() => {
    props.getLastSerialNumber();
  }, [getLastSerialNumber]);

  //---------------------TAB-1---------------------------------------------------------------------------
  const handleInputChange1 = (event) => {
    const { name, value } = event.target;
    let input;
    if (name === 'numOfSwitches') {
      if (value > 0 && value <= 16) {
        input = value
      }
      else {
        input = ''
      }
    }
    else {
      input = value;
    }
    props.updateForm({
      formAddDevice: {
        ...form.formAddDevice,
        formAddDevice1: {
          ...form.formAddDevice.formAddDevice1,
          [name]: input
        },
        errors1: {
          ...form && form.formAddDevice.errors1,
          [name]: null,
        }
      }
    });
  }

  const SwitchCountDec = () => {
    const { formAddDevice } = form || {};
    const { formAddDevice1 } = formAddDevice || {};
    const { numOfSwitches } = formAddDevice1 || {};
    const switchCount = numOfSwitches - 1;
    props.updateForm({
      formAddDevice: {
        ...form.formAddDevice,
        formAddDevice1: {
          ...form.formAddDevice.formAddDevice1,
          numOfSwitches: switchCount
        },
        errors1: {
          ...form && form.formAddDevice.errors1,
        }
      }
    });
  }
  const SwitchCountInc = () => {
    const { formAddDevice } = form || {};
    const { formAddDevice1 } = formAddDevice || {};
    const { numOfSwitches } = formAddDevice1 || {};
    const switchCount = numOfSwitches + 1;
    props.updateForm({
      formAddDevice: {
        ...form.formAddDevice,
        formAddDevice1: {
          ...form.formAddDevice.formAddDevice1,
          numOfSwitches: switchCount
        },
        errors1: {
          ...form && form.formAddDevice.errors1,
        }
      }
    });
  }

  const handleLoadProducts = (inputValue, callback) => {
    props.getAssignableProductsForAsyncSelect(inputValue, callback);
  };

  const handleAddProductChange = (value) => {
    props.addDeviceForm({ ...props.Adddeviceform, new_product: value });
    props.updateForm({
      formAddDevice: {
        ...form.formAddDevice,
        formAddDevice1: {
          ...form.formAddDevice.formAddDevice1,
          new_product: value
        },
        errors1: {
          ...form && form.formAddDevice.errors1,
          new_product: null,
        }
      }
    });
  };

  const handleNoOfSwitchChange = (newValue) => {

    props.addDeviceForm({ ...props.Adddeviceform, numOfSwitches: newValue });
    setNoOfSwitches(newValue);
    props.updateForm({
      formAddDevice: {
        ...form.formAddDevice,
        formAddDevice1: {
          ...form.formAddDevice.formAddDevice1,
          numOfSwitches: newValue
        },
        errors1: {
          ...form && form.formAddDevice.errors1,
          numOfSwitches: null,
        }
      }
    });

  };

  const handleNoOfSwitchFilter = (newValue) => {
    if (newValue !== '') {
      let switchesCount = newValue;
      props.addDeviceForm({ ...props.Adddeviceform, numOfSwitches: newValue });
      const numericValue = switchesCount.replace(/[^\d]/g, '');
      const numberInterval = numericValue === "" ? "" : numericValue.replace(/\b(?!1[0-6]\b|[1-9]\b)\d+\b/g, '');
      const noOfSwitches = numberInterval === "" ? { label: "", value: "" } : newValue;
      setNoOfSwitches(noOfSwitches);
      props.updateForm({
        formAddDevice: {
          ...form.formAddDevice,
          formAddDevice1: {
            ...form.formAddDevice.formAddDevice1,
            numOfSwitches: noOfSwitches
          },
          errors1: {
            ...form && form.formAddDevice.errors1,
            numOfSwitches: null,
          }
        }
      });
    }
  };

  //---------------------TAB-2---------------------------------------------------------------------------
  const handleInputChange2 = (event) => {
    const { name, value } = event.target;
    if (name === "SubscriptionValidate") {
      setValidationDate(value)
    }
    props.updateForm({
      formAddDevice: {
        ...form.formAddDevice,
        formAddDevice2: {
          ...form.formAddDevice.formAddDevice2,
          [name]: value
        },
        errors2: {
          ...form && form.formAddDevice.errors2,
          [name]: null,
        }
      }
    });
  }
  //---------------------TAB-3---------------------------------------------------------------------------
  const handleInputChange3 = (event) => {
    const { name, value } = event.target;
    if (name === 'amcStartDate') {
      setAmcDate({
        ...amcDate,
        amcStartDate: value,
      })
    }
    if (name === 'amcEndDate') {
      setAmcDate({
        ...amcDate,
        amcEndDate: value,
      })
    }

    props.updateForm({
      formAddDevice: {
        ...form.formAddDevice,
        formAddDevice3: {
          ...form.formAddDevice.formAddDevice3,
          [name]: value
        },
        errors3: {
          ...form && form.formAddDevice.errors3,
          [name]: null,
        }
      }
    });
  }
  const handleLoadOrganisation = (inputValue, callback) => {
    props.getOrganisationsForAsyncSelect(inputValue, callback);
  };

  const handleAddUserOrgChange = (value) => {
    props.addDeviceForm({ ...props.Adddeviceform, new_user_organisation: value })
    props.updateForm({
      formAddDevice: {
        ...form.formAddDevice,
        formAddDevice2: {
          ...form.formAddDevice.formAddDevice2,
          new_user_organisation: value
        },
        errors2: {
          ...form && form.formAddDevice.errors2,
          new_user_organisation: null,
        }
      }
    });
  };

  const getNoOfSwitcheOptions = () => {
    var noOfSwitchesArray = [];
    for (var i = 1; i <= NO_OF_SWITCHES; i++) {
      noOfSwitchesArray.push({ value: i, label: i.toString() });
    }
    return noOfSwitchesArray;
  };

  //---------------------VALIDATION & PAGE NAVIGATION-----------------------------------------------------------
  const toggleTabwiz = (tab) => {
    const { formAddDevice } = form || {};
    const { formAddDevice1, formAddDevice2, formAddDevice3 } = formAddDevice || {};
    const { new_product, hardwareVersion, firmwareVersion, sensorType, numOfSwitches, modelNo } = formAddDevice1 || {};
    const { new_user_organisation, noOfDevices, SubscriptionValidate } = formAddDevice2 || {};
    const { amcStatus, amcStartDate, amcEndDate } = formAddDevice3 || {};

    let errors = {};
    const currentErrors1 = {};
    const currentErrors2 = {};
    const currentErrors3 = {};
    //---------------------TAB-1-----------------------------------------------------------
    if (activeTabwiz === 1) {
      if (!new_product) {
        currentErrors1.new_product = "Product name is required"
      }
      if (!hardwareVersion) {
        currentErrors1.hardwareVersion = "Hardware version is required"
      }
      if (!firmwareVersion) {
        currentErrors1.firmwareVersion = "Firmware version is required"
      }
      if (!sensorType) {
        currentErrors1.sensorType = "Lot number is required"
      }
      if (!numOfSwitches) {
        currentErrors1.numOfSwitches = "Switches is required"
      }
      if (!modelNo) {
        currentErrors1.modelNo = "Model number is required"
      }

      props.updateForm({
        formAddDevice: {
          ...formAddDevice,
          formAddDevice1: {
            ...form.formAddDevice.formAddDevice1,
          },
          errors1: currentErrors1,
        }
      })

      errors = currentErrors1;
    }
    //---------------------TAB-2-----------------------------------------------------------
    if (activeTabwiz === 2) {
      if (!new_user_organisation) {
        currentErrors2.new_user_organisation = "Organization is required"
      }
      if (!noOfDevices) {
        currentErrors2.noOfDevices = "Switch count is required"
      }
      if (!noOfDevices) {
        currentErrors2.noOfDevices = "Switch count is required"
      }
      if (!SubscriptionValidate) {
        currentErrors2.SubscriptionValidate = "Subscription validity is required"
      }
      props.updateForm({
        formAddDevice: {
          ...formAddDevice,
          formAddDevice2: {
            ...form.formAddDevice.formAddDevice2,
          },
          errors2: currentErrors2,
        }
      })

      errors = currentErrors2
    }

    //---------------------TAB-3-----------------------------------------------------------
    if (activeTabwiz === 3) {
      if (!amcStatus) {
        currentErrors3.amcStatus = "AMC status is required"
      }
      if (!amcStartDate) {
        currentErrors3.amcStartDate = "AMC start date is required"
      }
      if (!amcEndDate) {
        currentErrors3.amcEndDate = "AMC end date is required"
      }
      props.updateForm({
        formAddDevice: {
          ...formAddDevice,
          formAddDevice3: {
            sessionId: uuidv4(),
            ...form.formAddDevice.formAddDevice3,
          },
          errors3: currentErrors3,
        }
      })

      errors = currentErrors3
    }

    if (Object.keys(errors).length === 0) {
      if (activeTabwiz !== tab) {
        var modifiedSteps = [...passedStepswiz, tab];
        if (tab >= 1 && tab <= 4) {
          setoggleTabwiz(tab);
          setpassedStepswiz(modifiedSteps);
        }
      }
    }
    else {
      if (activeTabwiz > tab) {
        var modifiedSteps = [...passedStepswiz, tab];
        if (tab >= 1 && tab <= 4) {
          setoggleTabwiz(tab);
          setpassedStepswiz(modifiedSteps);
        }
      }
    }
  }

  //---------------------DEVICE CREATE FORM SUBMISSION----------------------------------------------------
  const handleAddDevice = (e) => {
    e.preventDefault();
    const { lastSerialNo } = props;
    props.addDevices(lastSerialNo);
  };

  const noOfSwitchesOptions = getNoOfSwitcheOptions();

  return props.isSuccess ? (<Navigate to="/devicelist" />) : (
    <React.Fragment>
      <div className="page-content">
        <Row>
          <Col lg="12">
            <Card>
              <CardTitle className='d-flex justify-content-between align-items-center m-2 mb-0 border-bottom border-secondary'>
                <h5 className="fw-bold">CREATE DEVICE</h5>
                <Link to='/devicelist' className="text-dark">
                  <i className="mdi mdi-close fs-2"></i>
                </Link>
              </CardTitle>
              <CardBody>
                {errorMessage && (
                  <Message
                    type="danger"
                    defaultMessage={errorMessage}
                    baseClassName="alert"
                  />
                )}
                <div id="progrss-wizard" className="twitter-bs-wizard">
                  <ul className="twitter-bs-wizard-nav nav-justified nav nav-pills">
                    <NavItem className={classnames({ active: activeTabwiz === 1 })}>
                      <NavLink
                        className={(classnames({ active: activeTabwiz === 1 }))}
                        onClick={() => toggleTabwiz(1)}
                      >
                        <span className="step-number">01</span>
                        <span className="step-title" style={{ paddingLeft: "10px" }}>Product Details</span>
                      </NavLink>
                    </NavItem>
                    <NavItem className={classnames({ active: activeTabwiz === 2 })}>
                      <NavLink
                        className={(classnames({ active: activeTabwiz === 2 }))}
                        onClick={() => toggleTabwiz(2)}
                      >
                        <span className="step-number">02</span>
                        <span className="step-title" style={{ paddingLeft: "10px" }}>Organization Details</span>
                      </NavLink>
                    </NavItem>
                    <NavItem className={classnames({ active: activeTabwiz === 3 })}>
                      <NavLink
                        className={(classnames({ active: activeTabwiz === 3 }))}
                        onClick={() => toggleTabwiz(3)}
                      >
                        <span className="step-number">03</span>
                        <span className="step-title" style={{ paddingLeft: "10px" }}>AMC Details</span>
                      </NavLink>
                    </NavItem>
                    <NavItem className={classnames({ active: activeTabwiz === 4 })}>
                      <NavLink
                        className={(classnames({ active: activeTabwiz === 4 }))}
                        onClick={() => toggleTabwiz(4)}
                      >
                        <span className="step-number">04</span>
                        <span className="step-title" style={{ paddingLeft: "10px" }}>Confirm Details</span>
                      </NavLink>
                    </NavItem>
                  </ul>
                  <div id="bar" className="mt-4">
                    <div className="mb-4">
                      <Progress
                        value={40 * activeTabwiz}
                        color="success"
                        animated
                      />
                    </div>
                  </div>
                  <TabContent activeTab={activeTabwiz} className="twitter-bs-wizard-tab-content">
                    <TabPane tabId={1}>
                      <Form>
                        <Row>
                          <Col lg="6">
                            <FormGroup className="mb-3">
                              <Label htmlFor="basicpill-firstname-input12">
                                Product Name
                              </Label><span className="text-danger">*</span>
                              <Async
                                autoFocus
                                openMenuOnFocus={true}
                                styles={{
                                  control: (baseStyles) => ({
                                    ...baseStyles,
                                    borderColor: (form && form.formAddDevice
                                      && form.formAddDevice.errors1 &&
                                      form.formAddDevice.errors1.new_product) ? 'red' : ""
                                  })
                                }}
                                name="new_product"
                                placeholder="Select product"
                                defaultOptions
                                menuPortalTarget={document.body}
                                loadOptions={handleLoadProducts}
                                onChange={handleAddProductChange}
                                value={new_product}
                              />
                              {(form && form.formAddDevice
                                && form.formAddDevice.errors1 &&
                                form.formAddDevice.errors1.new_product) &&
                                <FormText sx={{ marginLeft: "10px" }}>
                                  <div className="text-danger">
                                    {form && form.formAddDevice
                                      && form.formAddDevice.errors2 &&
                                      form.formAddDevice.errors1.new_product}
                                  </div>
                                </FormText>
                              }
                            </FormGroup>
                          </Col>
                          <Col lg="6">
                            <FormGroup className="mb-3">
                              <Label htmlFor="basicpill-lastname-input22">
                                Model Number
                              </Label><span className="text-danger">*</span>
                              <Input
                                // id="basicpill-lastname-input22"
                                className="form-control"
                                type="text"
                                name="modelNo"
                                placeholder="Enter device model number"
                                onChange={handleInputChange1}
                                invalid={form && form.formAddDevice
                                  && form.formAddDevice.errors1 &&
                                  form.formAddDevice.errors1.modelNo}
                              />
                              <FormFeedback>
                                {form && form.formAddDevice
                                  && form.formAddDevice.errors1 &&
                                  form.formAddDevice.errors1.modelNo}
                              </FormFeedback>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="6">
                            <FormGroup className="mb-3">
                              <Label htmlFor="basicpill-lastname-input22">
                                Hardware Version
                              </Label><span className="text-danger">*</span>
                              <Input
                                // id="basicpill-lastname-input22"
                                className="form-control"
                                type="text"
                                name="hardwareVersion"
                                placeholder="Enter device hardware version"
                                onChange={handleInputChange1}
                                invalid={form && form.formAddDevice
                                  && form.formAddDevice.errors1 &&
                                  form.formAddDevice.errors1.hardwareVersion}
                              />
                              <FormFeedback>
                                {form && form.formAddDevice
                                  && form.formAddDevice.errors1 &&
                                  form.formAddDevice.errors1.hardwareVersion}
                              </FormFeedback>
                            </FormGroup>
                          </Col>
                          <Col lg="6">
                            <FormGroup className="mb-3">
                              <Label htmlFor="basicpill-email-input42">
                                Firmware Version
                              </Label><span className="text-danger">*</span>
                              <Input
                                // id="basicpill-email-input42"
                                className="form-control"
                                name="firmwareVersion"
                                type="text"
                                placeholder="Enter device firmware version"
                                onChange={handleInputChange1}
                                invalid={form && form.formAddDevice
                                  && form.formAddDevice.errors1 &&
                                  form.formAddDevice.errors1.firmwareVersion}
                              />
                              <FormFeedback>
                                {form && form.formAddDevice
                                  && form.formAddDevice.errors1 &&
                                  form.formAddDevice.errors1.firmwareVersion}
                              </FormFeedback>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="6">
                            <FormGroup className="mb-3">
                              <Label htmlFor="basicpill-address-input12">
                                No. Of Switches
                              </Label><span className="text-danger">*</span>
                              <Row>
                                <Col md='12'>
                                  <Input
                                    type='number'
                                    name="numOfSwitches"
                                    placeholder="Enter no of Switches"
                                    min={1}
                                    max={16}
                                    onChange={handleInputChange1}
                                    onKeyDown={
                                      (e) => ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault()
                                    }
                                    value={form && form.formAddDevice
                                      && form.formAddDevice.formAddDevice1 &&
                                      form.formAddDevice.formAddDevice1.numOfSwitches}
                                    invalid={form && form.formAddDevice
                                      && form.formAddDevice.errors1 &&
                                      form.formAddDevice.errors1.numOfSwitches}
                                  />
                                  <FormFeedback>
                                    {form && form.formAddDevice
                                      && form.formAddDevice.errors1 &&
                                      form.formAddDevice.errors1.numOfSwitches}
                                  </FormFeedback>
                                  <span className="form-text">
                                    <b>TIP :</b> The range of switches was 1 to 16. Do not attempt to enter numbers that exceed the limit.
                                    <br />
                                  </span>
                                </Col>
                              </Row>
                            </FormGroup>
                          </Col>
                          <Col lg="6">
                            <FormGroup className="mb-3">
                              <Label htmlFor="basicpill-address-input12">
                                Lot Number
                              </Label><span className="text-danger">*</span>
                              <Input
                                id="basicpill-address-input12"
                                className="form-control"
                                name="sensorType"
                                placeholder="Enter lot number"
                                onChange={handleInputChange1}
                                invalid={form && form.formAddDevice
                                  && form.formAddDevice.errors1 &&
                                  form.formAddDevice.errors1.sensorType}
                              />
                              <FormFeedback>
                                {form && form.formAddDevice
                                  && form.formAddDevice.errors1 &&
                                  form.formAddDevice.errors1.sensorType}
                              </FormFeedback>
                            </FormGroup>
                          </Col>
                        </Row>
                      </Form>
                    </TabPane>
                    <TabPane tabId={2}>
                      <div>
                        <Form>
                          <Row>
                            <Col lg="6">
                              <FormGroup className="mb-3">
                                <Label htmlFor="basicpill-pancard-input52">
                                  Organization Name
                                </Label><span className="text-danger">*</span>
                                <Async
                                  id="new_user_organisation"
                                  styles={{
                                    control: (baseStyles) => ({
                                      ...baseStyles,
                                      borderColor: (form && form.formAddDevice
                                        && form.formAddDevice.errors2 &&
                                        form.formAddDevice.errors2.new_user_organisation) ? 'red' : ""
                                    })
                                  }}
                                  name="new_user_organisation"
                                  placeholder="Select organization"
                                  isDisabled={!isSuperAdmin}
                                  defaultOptions
                                  loadOptions={(isSuperAdmin) && (handleLoadOrganisation)}
                                  onChange={handleAddUserOrgChange}
                                  value={new_user_organisation}
                                />
                                {(form && form.formAddDevice
                                  && form.formAddDevice.errors2 &&
                                  form.formAddDevice.errors2.new_user_organisation) &&
                                  <FormText sx={{ marginLeft: "10px" }}>
                                    <div className="text-danger">
                                      {form && form.formAddDevice
                                        && form.formAddDevice.errors2 &&
                                        form.formAddDevice.errors2.new_user_organisation}
                                    </div>
                                  </FormText>
                                }
                              </FormGroup>
                            </Col>
                            <Col lg="6">
                              <FormGroup className="mb-3">
                                <Label htmlFor="basicpill-vatno-input62">
                                  Subscription Validity<span className="text-danger">*</span>
                                </Label>
                                <Input
                                  type="date"
                                  name="SubscriptionValidate"
                                  className="form-control"
                                  id="basicpill-vatno-input62"
                                  placeholder="Enter device subscription validity"
                                  onChange={handleInputChange2}
                                  value={validationDate}
                                  invalid={form && form.formAddDevice
                                    && form.formAddDevice.errors2 &&
                                    form.formAddDevice.errors2.SubscriptionValidate}
                                />
                                <FormFeedback>
                                  {form && form.formAddDevice
                                    && form.formAddDevice.errors2 &&
                                    form.formAddDevice.errors2.SubscriptionValidate}
                                </FormFeedback>
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col lg="6">
                              <FormGroup className="mb-3">
                                <Label htmlFor="basicpill-cstno-input72">
                                  No. Of Devices
                                </Label><span className="text-danger">*</span>
                                <Input
                                  type="number"
                                  min={1}
                                  max={1000}
                                  name="noOfDevices"
                                  className="form-control"
                                  id="basicpill-cstno-input72"
                                  placeholder="Enter no of devices"
                                  onChange={handleInputChange2}
                                  invalid={form && form.formAddDevice
                                    && form.formAddDevice.errors2 &&
                                    form.formAddDevice.errors2.noOfDevices}
                                />
                                <FormFeedback>
                                  {form && form.formAddDevice
                                    && form.formAddDevice.errors2 &&
                                    form.formAddDevice.errors2.noOfDevices}
                                </FormFeedback>
                              </FormGroup>
                              <Col lg="12">
                                <FormGroup className="mb-3">
                                  <span className="form-text">
                                    <b>TIP :</b> No of devices will be added automatically based on the above input.
                                    <br />
                                    <b>LAST SERIAL NO : </b>{lastSerialNo}
                                  </span>
                                </FormGroup>
                              </Col>
                            </Col>
                            <Col lg="6">
                              <FormGroup className="mb-3">
                                <Label htmlFor="basicpill-vatno-input62">
                                  Description
                                </Label>
                                <Input
                                  type="text"
                                  name="description"
                                  className="form-control"
                                  id="basicpill-vatno-input62"
                                  placeholder="Enter device description"
                                  onChange={handleInputChange2}
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                        </Form>
                      </div>
                    </TabPane>
                    <TabPane tabId={3}>
                      <Form>
                        <Row>
                          <Col lg="6">
                            <FormGroup className="mb-3">
                              <Label htmlFor="basicpill-vatno-input62">
                                AMC Start Date
                              </Label><span className="text-danger">*</span>
                              <Input
                                type="date"
                                name="amcStartDate"
                                className="form-control"
                                id="basicpill-vatno-input62"
                                placeholder="Enter device AMC start date"
                                onChange={handleInputChange3}
                                value={amcDate && amcDate.amcStartDate}
                                invalid={form && form.formAddDevice
                                  && form.formAddDevice.errors3 &&
                                  form.formAddDevice.errors3.amcStartDate}
                              />
                              <FormFeedback>
                                {form && form.formAddDevice
                                  && form.formAddDevice.errors3 &&
                                  form.formAddDevice.errors3.AMCStartDate}
                              </FormFeedback>
                            </FormGroup>
                          </Col>
                          <Col lg="6">
                            <FormGroup className="mb-3">
                              <Label htmlFor="basicpill-vatno-input62">
                                AMC End Date
                              </Label><span className="text-danger">*</span>
                              <Input
                                type="date"
                                name="amcEndDate"
                                className="form-control"
                                id="basicpill-vatno-input62"
                                placeholder="Enter device AMC end date"
                                onChange={handleInputChange3}
                                value={amcDate && amcDate.amcEndDate}
                                invalid={form && form.formAddDevice
                                  && form.formAddDevice.errors3 &&
                                  form.formAddDevice.errors3.amcEndDate}
                              />
                              <FormFeedback>
                                {form && form.formAddDevice
                                  && form.formAddDevice.errors3 &&
                                  form.formAddDevice.errors3.AMCEndDate}
                              </FormFeedback>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="6">
                            <FormGroup className="mb-3">
                              <Label htmlFor="basicpill-vatno-input62">
                                AMC Status
                              </Label><span className="text-danger">*</span>
                              <Input
                                type="select"
                                name="amcStatus"
                                className="form-control"
                                id="basicpill-vatno-input62"
                                placeholder="Enter device AMC status"
                                onChange={handleInputChange3}
                                invalid={form && form.formAddDevice
                                  && form.formAddDevice.errors3 &&
                                  form.formAddDevice.errors3.amcStatus}
                              >
                                <option value="">Select</option>
                                {AMC_STATUS_OPTIONS && AMC_STATUS_OPTIONS.map((option) => (
                                  <option key={option.value} value={option.value}>
                                    {option.label}
                                  </option>
                                ))}
                              </Input>
                              <FormFeedback>
                                {form && form.formAddDevice
                                  && form.formAddDevice.errors3 &&
                                  form.formAddDevice.errors3.amcStatus}
                              </FormFeedback>
                            </FormGroup>
                          </Col>
                        </Row>
                      </Form>
                    </TabPane>
                    <TabPane tabId={4}>
                      <div className="row justify-content-center">
                        <Col lg="12">
                          {isPending ?
                            <VWLoading /> :
                            <div className="text-center">
                              <div className="mb-4">
                                <i className="mdi mdi-check-circle-outline text-success display-4" />
                              </div>
                              <div>
                                <h5>Confirm Details</h5>
                                <p className="text-muted">
                                  New device is going to create as per your inputs. Are you sure to create?
                                </p>
                              </div>
                              <Button color="success" type="primary" onClick={handleAddDevice}>Submit</Button>
                              <Link className="btn btn-danger ms-4" to='/devicelist'>
                                Cancel
                              </Link>
                            </div>}
                        </Col>
                      </div>
                    </TabPane>
                  </TabContent>
                  <ul className="pager wizard twitter-bs-wizard-pager-link">
                    <li className={activeTabwiz === 1 ? "previous disabled me-2" : "previous me-2"}>
                      {activeTabwiz !== 1 && <Button
                        color='primary'
                        onClick={() => toggleTabwiz(activeTabwiz - 1)}
                        disabled={activeTabwiz === 1}>
                        Previous
                      </Button>
                      }
                    </li>
                    <li className={activeTabwiz === 4 ? "next disabled" : "next"}>
                      {activeTabwiz !== 4 && <Button
                        color='primary'
                        onClick={() => toggleTabwiz(activeTabwiz + 1)}
                        disabled={activeTabwiz === 4}>
                        Next
                      </Button>
                      }
                    </li>
                  </ul>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
        {/* </Container> */}
      </div>
    </React.Fragment >
  );
};

const mapStateToProps = (state) => ({
  Adddeviceform: state.device.Adddeviceform,
  lastSerialNo: state.device.lastSerialNo,
  currentProfile: state.login.currentProfile,
  errorMessage: state.device.createDeviceError,
  isSuccess: state.device.isSuccess,
  isPending: state.device.isPending,
  form: state.form.form,
});

const mapDispatchToProps = (dispatch) => ({
  updateForm: (AddDevices) => dispatch(updateForm(AddDevices)),
  clearForm: () => dispatch(clearForm()),
  addDeviceForm: (Adddeviceform) => dispatch(addDeviceForm(Adddeviceform)),
  getOrganisationsForAsyncSelect: (searchValue, callback) => dispatch(getOrganisationsForAsyncSelect(searchValue, callback)),
  getAssignableProductsForAsyncSelect: (searchValue, callback) => dispatch(getAssignableProductsForAsyncSelect(searchValue, callback)),
  addDevices: (lastSerialNo) => dispatch(addDevices(lastSerialNo)),
  getLastSerialNumber: () => dispatch(getLastSerialNumber()),
  clearCreateDeviceError: () => dispatch(clearCreateDeviceError()),
});

export default connect(mapStateToProps, mapDispatchToProps)(FormWizard);